import httpClient from "../http/http-client";
import { IImportMapping, IPatchImportMapping, IPostImportMapping } from './import-mapping.model';

export default class ImportMappingService {
  http;

  constructor() {
    this.http = httpClient
  }

  async create(importMapping: IPostImportMapping): Promise<IImportMapping> {
    return this.http.post(`import-mapping`, importMapping)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async edit(importMappingId: string, importMapping: IPatchImportMapping): Promise<IImportMapping> {
    return this.http.patch(`import-mapping/${importMappingId}`, importMapping)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async delete(importMappingId: string): Promise<IImportMapping> {
    return this.http.delete(`import-mapping/${importMappingId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}